// extracted by css-extract-rspack-plugin
export default {"root":"CtkdT","error":"E4zn9"};